export const graph = {
  name: "graph" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" fill="currentColor"><path fill-rule="evenodd" d="M3.5 2.6a.9.9 0 0 1 .9.9v16.6H21a.9.9 0 0 1 0 1.8H3.5a.9.9 0 0 1-.9-.9V3.5a.9.9 0 0 1 .9-.9Zm12 5.3a.9.9 0 1 1 0-1.8H20a.9.9 0 0 1 .9.9v4.5a.9.9 0 0 1-1.8 0V9.173l-5.464 5.463a.9.9 0 0 1-1.272 0L10 12.273l-2.864 2.863a.9.9 0 1 1-1.272-1.272l3.5-3.5a.9.9 0 0 1 1.272 0L13 12.727 17.827 7.9H15.5Z" clip-rule="evenodd"/></svg>`,
  keywords: ["graph"],
  category: "file" as const,
};
